
<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
<!--         <preLoader v-if="loader"></preLoader>-->
        <div class="container">

         <div class="form-group" style="margin-top: 30px">
            <router-link to="/product" class="btn btn-default">{{ $t('Back') }}</router-link>
        </div>

          <CRow class="justify-content-md-center">
            <CCol sm="6">
              <CCard>
                <form v-on:submit.prevent="saveForm()">



                  <CCardHeader>
                    <strong> ویرایش کالا  </strong>
                    <!--                        <div class="card-header-actions">-->
                    <!--                            <a-->
                    <!--                                    href="#"-->
                    <!--                                    class="card-header-action"-->
                    <!--                                    rel="noreferrer noopener"-->
                    <!--                                    target="_blank"-->
                    <!--                            >-->
                    <!--                                <small class="text-muted">خروجی اکسل</small>-->
                    <!--                            </a>-->
                    <!--                        </div>-->
                  </CCardHeader>
                  <CCardBody  class="p-5">

                   


                  
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('categories') }}</label>
                              <v-select style="min-width: 225px"
                                        v-model="item.product_category_id"
                                        :options="product_categories" label="title" :reduce="product_category => product_category.id" value="id">
                              </v-select>
                            </div>
                        </div>








                    <div class="row">
                        <div class="col-xs-12 form-group">
                            <label class="control-label"> {{ $t('Title') }}</label>
                            <input type="text" v-model="item.title" class="form-control">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 form-group">
                            <label class="control-label"> Code</label>
                            <input type="text" v-model="item.code" class="form-control">
                        </div>
                    </div>
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Description') }}</label>
                                <input type="text" v-model="item.description" class="form-control">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Initial amount') }}</label>
                                <input type="text" v-model="item.remaining_number" class="form-control">
                            </div>
                        </div>



                        <div class="row">
                            <div  v-if="$store.state.access" class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Price(toman)') }}</label>
                                <input type="text" v-model="item.price" class="form-control">
                            </div>
                        </div>


                        <!-- <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label"></label>
                                <input type="text" v-model="item.min_time" class="form-control">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">حداکثر زمان</label>
                                <input type="text" v-model="item.max_time" class="form-control">
                            </div>
                        </div> -->
                         <!--<div class="row">-->
                            <!--<div class="col-xs-12 form-group">-->
                                <!--<label class="control-label">مالیات</label>-->
                                <!--<input type="text" v-model="item.tax" class="form-control">-->
                            <!--</div>-->
                        <!--</div>-->
                         <!--
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">تخفیف</label>
                                <input type="text" v-model="item.default_discount" class="form-control">
                            </div>
                        </div> -->

<!--                    <div class="row">-->
<!--                        <div class="col-xs-12 form-group">-->
<!--                            <label class="control-label">{{ $t('Score') }}</label>-->
<!--                            <input type="text" v-model="item.score" class="form-control">-->
<!--                        </div>-->
<!--                    </div>-->

                  <div class="row">
                    <div class="col-xs-12 form-group">
                      <label class="control-label">تاریخ تولید</label>
                      <custom-time-picker
                          v-model="item.min_time"  lable="تاریخ تولید"
                          type="date" :clearable="true" placeholder="تاریخ تولید" min="" max=""
                          size="sm" input-class="form-control form-control-sm">
                      </custom-time-picker>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 form-group">
                      <label class="control-label"> تاریخ انقضا</label>
                      <custom-time-picker
                                          v-model="item.max_time"  lable="تاریخ انقضا"
                                          type="date" :clearable="true" placeholder="تاریخ انقضا" min="" max=""
                                          size="sm" input-class="form-control form-control-sm">
                      </custom-time-picker>
                    </div>
                  </div>


                  <div class="row">
                    <div class="col-xs-12 form-group">
                      <label class="control-label"> سری تولید</label>
                      <input type="text" v-model="item.reference" class="form-control">
                    </div>
                  </div>

                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Image') }}</label>
                                <div class="form-group">
                                    <div class="input-group input-file" name="Fichier1">
                                        <input type="text" class="form-control" :placeholder="placeholder" />
                                        <input type="file" class="filestyle" ref="file"
                                            @change="onFileChange($event)" />
<!--                                        <span class="input-group-btn">-->
<!--                                            <button class="btn btn-default btn-choose" type="button">{{ $t('File') }} </button>-->
<!--                                        </span>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('unit') }} </label>
                              <select v-model="item.unit" class="form-control"  style="min-width: 225px">
                                <option v-for="(unit,index) in units" :value="unit.id" :key="index">
                                  {{ unit.title}}
                                </option>
                              </select>
<!--                                <select class="form-control" v-model="item.unit ">-->
<!--                                    <option value="0"> {{ $t('Number') }}</option>-->
<!--                                    <option value="1">{{ $t('g') }}</option>-->
<!--                                    <option value="2">{{ $t('Kg') }}</option>-->
<!--                                    <option value="3">{{ $t('Liter') }}</option>-->
<!--                                    <option value="4">{{ $t('packet') }}</option>-->
<!--                                </select>-->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('status') }}</label>
                                <select class="form-control" v-model="item.state"  style="min-width: 225px">
                                    <option value="0">{{ $t('Inactive') }}</option>
                                    <option value="1">{{ $t('Active') }}</option>

                                </select>
                            </div>
                        </div>

                    <div class="row">
                        <div class="col-xs-12 form-group">
                            <button class="btn btn-success">{{ $t('Edit') }}</button>
                        </div>
                    </div>


                  </CCardBody>

                </form>
            </CCard>
        </CCol>
    </CRow>
    </div>
    </div>
</template>

<script>


    const auth = {
        headers: {Authorization:'bearer ' + localStorage.getItem('token'), 'Content-Type': 'application/x-www-form-urlencoded'}
    };


    export default {

        mounted() {

          this.$store.state.roles = this.pluck(JSON.parse(localStorage.getItem('roles')), 'name')
          this.$store.state.accesses = ['superadministrator', 'admin']
          this.$store.commit('intersection')
          this.$store.commit('checkIntersection')


            let app = this;
            let id = app.$route.params.id;
            app.loader=true
            app.itemId = id;
            axios
                .get('/api/products/' + id , app.auth)
                .then(function (resp) {
                    app.item = resp.data;
                    app.loader=false
                     console.log(resp)
                })
                .catch(function (e) {
                    app.loader=false
                     for (let value of e.response.data.messages_fa) {
//                        for (let error of Object.entries(value[1])) {
//                            console.log(app.object.entries(app.errors[0]));

                            app.$snotify.warning(value,
                                {
                                    timeout: 7000,
//                                    showProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true
                                });

//                        }
                        }
                });



            axios
                .get('/api/productCategorieslist', app.auth)
                .then(function (resp) {
                    app.product_categories = resp.data;
                         console.log(app.product_categories)
                })

                .catch(function () {

                    
                    alert(this.$t('Unable to load item'));
//                    console.log('a: ' + auth)
                });



          this.getUnits()

        },


        data: function () {
            return {
                auth: {headers: {Authorization: 'bearer ' + localStorage.getItem('token')}},
                itemId: null,
                product_categories:[],
                placeholder: "فایل را انتخاب کنید...",
                item: {
                    parent_id: '',
                    product_category_id: '',
                    title: '',
                    image: null,
                    description: '',
                    initial_number: '',
                    price: '',
                    tax: 0,
                    unit: '',
                    min_time: '',
                    max_time: ''


                },
                loader:false,
                errors: [],
                service_categories: [],
                units: []


            }
        },


        methods: {
             onFileChange(e) {

                //    console.log(e.target.files[0])
                this.item.image = this.$refs.file.files[0];
                this.placeholder = this.$refs.file.files[0].name
                console.log(this.item.image, "144")

            },
            saveForm() {
                var app = this;
                app.loader=true
                var newItem = app.item;
                let formData = new FormData();
                formData.append("_method","PATCH")
                //  formData.append(key, element)
                for (const key in newItem) {
                    if (newItem.hasOwnProperty(key)) {
                        const element = newItem[key];
                        if(element !== null)
                        formData.append(key, element)
                        // console.log(key, element);
                    }
                }
                axios.post('/api/products/' + app.itemId, formData , app.auth)
                    .then(function (resp) {
                        app.$router.replace('/product');
                        app.$snotify.info(app.$t('Successfully registered'))
                        this.loader=false
                    })
                    .catch(function (resp) {
                        this.loader=false
                        console.log(resp);
                        this.errors.push(resp.response.data.messages);
                            for (let value of e.response.data.messages_fa) {
                            app.$snotify.warning(value,
                                {
                                    timeout: 7000,

                                    closeOnClick: true,
                                    pauseOnHover: true
                                });
                             }
                    });
            },

          pluck(array, key) {
            return array.map(function (obj) {
              return obj[key];
            });
          },


          getUnits() {
            axios
                .get('/api/unitList', this.auth)
                .then(response => {

                  this.units = response.data;
                })
                .catch(error => {
                  console.log(error);
                  this.errored = true
                })
          },


        }
    }
</script>
